<template>
  <div class="row boxes-row">
    <div :class="boxClass" v-for="box in boxes" :key="box.idNews">
      <NewsBox :news="box"></NewsBox>
    </div>
  </div>
</template>

<script>
import NewsBox from "@/components/news/NewsBox";
export default {
  components: {NewsBox},
  props: ['boxClass', 'boxes'],
  name: "NewsGrid"
}
</script>

<style scoped>

</style>